import React from 'react'
import left from '../assets/left.png'

export default function BackButton({title}) {
  return (
    <div className='back-button' onClick={()=>window.history.back()}>
         <img src={left} />
         <h1 className='m-0' >{title}</h1>
    </div>
  )
}
